<template>
  <div>
    <el-dialog custom-class="customDialog" :close-on-click-modal="false" :visible.sync="showModal"
      :width="labelWidth === '210px' ? '70%' : '100%'" :close-on-press-escape="false" :show-close="false" top="4vh"
      append-to-body @open="opened()">


      <el-form ref="policy" :model="item" :label-width="labelWidth" :label-position="labelPosition" size="small"
        :rules="rules" v-loading="loading">


        <h3>{{$t('Müraciət')}}</h3>
        <hr width="100%" size="50" style=" margin-top: 0;position: relative;height: 1px;background: #F3EFE0;"
          align="center">
        <div v-if="standalone && !found" class="d-flex flex-column">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <div class="d-flex" style="gap: 10px;">


              <el-form-item label-width="90px">
                <el-input :placeholder="$t('SŞ_nömrəsi')" @keyup.enter.native="focusSearch(searchPolicyNumber)" v-upper
                  v-mask="'XXXXXXXXXXXX'" v-model="searchPolicyNumber" size="small" style="width: 200px;">
                  <template v-if="!found" #append>
                    <el-button class="primary" size="small" icon="el-icon-search"
                      @click="onsearch(searchPolicyNumber)" />
                  </template>
                </el-input>
              </el-form-item>
            </div>

            <div class="text-left" style="min-width: 120px;">
              <div style="font-size:24pt;">{{ timer }}</div>
            </div>
          </div>
          <hr width="100%" size="50" style=" margin-top: 0;position: relative;height: 0.5px;background: #f5f4f3;"
            align="center">
        </div>
        <br />

        <h6 v-if="!found">{{$t('Sığortalının_məlumatları')}}</h6>
        <div v-if="!found" class="row">
          <div class="col-md-6 col-12">
            <el-form-item :label="$t('Sığorta_növü')" prop="policyTypeId" label-width="100px">
              <policy-types v-model="item.policyType" :type="selectedType" @policytype="item.policyTypeName = $event" />
            </el-form-item>
            <el-form-item prop="policyNumber" for="policyNumberInput" v-if="!found" :label="$t('SŞ')">
              <el-input v-upper v-model="item.policyNumber" id="policyNumberInput" :placeholder="$t('SŞ')"
                :readonly="notfound && standalone">
              </el-input>
            </el-form-item>
            <el-form-item prop="insuredName" for="insuredNameInput" v-if="!found" :label="$t('Sığortalı')">
              <el-input v-upper v-model="item.insuredName" id="insuredNameInput" placeholder="ASA"
                :readonly="notfound && standalone">
              </el-input>
            </el-form-item>


          </div>
          <div class="col-md-6 col-12">
            <el-form-item v-if="item.insuranceType === 1" :label="$t('Sığorta_müddəti_(İcbari)')"
              prop="compulsoryPeriod">
              <el-input readonly v-model="compulsoryPeriod"></el-input>
            </el-form-item>
            <el-form-item v-else-if="item.insuranceType == 2" label="Sigorta müddəti (Könüllü)" prop="voluntaryPeriod">
              <el-input readonly v-model="voluntaryPeriod"></el-input>
            </el-form-item>
            <el-form-item :label="$t('Telefon_nömrəsi')" v-if="!found" prop="phone">
              <el-input v-model="item.phone" :readonly="notfound && standalone" type="tel"
                placeholder="+994 (__) ___-__-__" v-mask="'+994 (##) ###-##-##'" />
            </el-form-item>
            <el-form-item :label="$t('Ünvan')" v-if="item.policyType === 2">
              <el-input v-model="item.address" :readonly="notfound && standalone">
              </el-input>
            </el-form-item>
          </div>
        </div>
        <hr v-if="!found && (item.policyType === 2 || item.policyType === 3)" width="100%" size="50"
          style="margin-top: 0; position: relative;height: 1px;background: #F3EFE0;" align="center">
        <h6 v-if="item.policyType === 2">Əmlak sahibinin məlumatları</h6>
        <h6 v-if="item.policyType === 3">Yük sahibinin məlumatları</h6>
        <div class="row" v-if="item.policyType === 2 || item.policyType === 3">
          <div v-if="!found" class="col-md-12 col-12">
            <el-form-item prop="driverNoInfo">
              <el-checkbox v-model="item.driverNoInfo">{{$t('Məlumat_yoxdur')}}</el-checkbox>
            </el-form-item>
            <el-form-item v-if="item.driverNoInfo" prop="driverDescr" :label="$t('Qeyd')">
              <el-input v-model="item.driverDescr"></el-input>
            </el-form-item>
          </div>
          <div v-if="!item.driverNoInfo" class="col-md-6 col-12">
            <div class="row">
              <div :class="!found ? 'col-md-9 col-12' : 'col-md-12 col-12'">
                <el-form-item :label="item.policyType === 2 ? $t('Əmlak_sahibi') : $t('Yük_sahibi')" prop="driver">
                  <div>
                    <el-checkbox @change="onIsInsured" v-model="isInsured">
                      {{$t('Sığortalı_ilə_eynidir')}}
                    </el-checkbox>

                    <el-input v-upper v-letter :placeholder="$t('ASA')" v-model="item.driver" size="small">
                    </el-input>
                  </div>
                </el-form-item>
              </div>
              <div class="col-md-12 col-12">
                <div class="row">
                  <div :class="!found ? 'col-md-9 col-12' : 'col-md-12 col-12'">

                    <el-form-item :label="item.policyType === 2 ? $t('Əmlak_sahibi_nömrəsi') : $t('Yük_sahibi_nömrəsi')"
                      prop="driverPhone">
                      <el-checkbox @change="onIsInsuredPhone" v-model="isInsuredPhone">
                        {{$t('Telefon_nömrəsi_eynidir')}}
                      </el-checkbox>

                      <phone v-model="item.driverPhone" />
                    </el-form-item>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-12">
            <el-form-item :label="$t('Əlavə_nömrə')" v-if="!item.driverNoInfo" prop="callPhone">
              <phone v-model="item.callPhone" />
            </el-form-item>
          </div>
        </div>
        <hr width="100%" size="50" style="margin-top: 0; position: relative;height: 1px;background: #F3EFE0;"
          align="center">
        <h6>{{$t('Qarşı_tərəf')}}</h6>
        <div class="row">
          <div class="col-md-6 col-12">
          </div>
          <div class="col-md-6 col-12" style="margin-top: -30px;">
            <el-form-item :label="$t('Zərərvuran_sayı')" prop="vehicleCount">
              <el-input-number v-model="item.vehicleCount" :min="1" :max="10" @change="addOppositeSide" />
            </el-form-item>
          </div>
        </div>
        <div>
          <div class="row" v-for="(item, index) in oppositeSide" :key="item.id" style="border: 1px solid #ccc;">
            <div class="col-md-6 col-12">
              <el-form-item prop="noInfo">

                <el-tag style="margin: 5px 0 0 0; transform: scale(0.8); transform-origin: top left;">
                  {{ index + 1 }}
                </el-tag>
              </el-form-item>
              <div style="margin-top: -15px;">
                <el-form-item prop="noInfo">

                  <el-checkbox :true-label="1" :false-label="0" :label="$t('Məlumat_verilməyib')"
                    v-model="item.noInfo"></el-checkbox>

                </el-form-item>
              </div>

            </div>

            <div class="col-md-6 col-12" style="text-align: right;margin-top: 5px;">
              <el-button size="small" style="text-align: right" v-if="oppositeSide.length > 1"
                @click="deleteOppositeSide(index)"><i class="fa-solid fa-trash-can"></i></el-button>
            </div>
            <div v-if="!item.noInfo" class="col-md-6 col-12">
              <el-form-item :label="$t('A.S.A')" prop="personName">
                <el-input v-model="item.personName"></el-input>
              </el-form-item>
            </div>
            <div v-if="!item.noInfo" class="col-md-6 col-12">
              <el-form-item :label="$t('Nömrə')" prop="phone">
                <phone v-model="item.phone" />
              </el-form-item>
            </div>
          </div>
        </div>

        <br>
        <hr v-if="!found" width="100%" size="50"
          style="margin-top: 0; position: relative;height: 1px;background: #F3EFE0;" align="center">
        <h6>{{$t('Hadisə_məlumatları')}}</h6>
        <div class="row">
          <div class="col-md-6 col-12">
            <el-form-item :label="$t('Hadisə_vaxtı')" prop="accidentDate">
              <date-time-picker ref="datePicker" @input="inputDate" :optionDate="this.callDate"
                :date="accidentDateValue.date" :time="accidentDateValue.time"></date-time-picker>
              <el-date-picker v-show="false" v-model="item.accidentDate"></el-date-picker>
            </el-form-item>

            <el-form-item :label="$t('Hadisə_yeri')" prop="place">
              <el-input v-model="item.place"></el-input>
            </el-form-item>

          </div>
          <div class="col-md-6 col-12">
            <el-form-item :label="$t('Ərazi')" prop="regionId">
              <regions v-model="item.regionId" @region="item.regionName = $event" />
            </el-form-item>
            <!-- <el-form-item :label="$t('Qəza_komissarı')" v-if="item.policyType === 2 || item.policyType === 3"
              prop="accidentCommUid">
              <comm-users :region=true v-model="item.accidentCommUid" @comm="item.accidentCommUserName = $event" />
            </el-form-item> -->

            <el-form-item :label="$t('Ofisə_yaxınlaşıb')" prop="approachedOffice">
              <el-radio-group v-model="item.approachedOffice">
                <el-radio :label="1">{{$t('Bəli')}}</el-radio>
                <el-radio :label="0">{{$t('Xeyr')}}</el-radio>
              </el-radio-group>
            </el-form-item>


          </div>

        </div>
        <div class="row">
          <div class="col-md-12 col-12">
            <el-form-item prop="descr" :label="$t('Qeyd')">
              <el-input v-model="item.descr"></el-input>
            </el-form-item>
          </div>
        </div>

      </el-form>
      <span slot="footer" class="dialog-footer">

        <el-button size="small" type="primary" @click="clickSave">{{$t('Qeydə_al')}}</el-button>
        <el-button size="small" @click="clickReject">{{$t('İmtina')}}</el-button>
      </span>
    </el-dialog>
    <accident-view ref="accident" />
  </div>
</template>

<script>
  import { AccidentType, PolicyStatusType } from "../../services/types";
  import { standalone, labelPosition } from "../../services/helper";
  import { mask } from "vue-the-mask";
  import Regions from "../components/Regions.vue";
  import {
    CreateAccident,
    UpdateAccident,
    GetAccident,
  } from "../../services/accident";
  import {
    PolicyStatusInsert,
    CreateOppositeSide,
    GetOppositeSide,
    GetOppositeSides,
    UpdateOppositeSide,
    DeleteOppositeSide,
    GetRecentAccident
  } from "../../services/common";
  import Phone from "../components/Phone.vue";
  import { DateTimeToJson, DateToString, DateTimeToString, DateTimeReverseToString } from "../../services/helper";
  import { salesapi, newsalesapi } from "../../services/sales";
  import DateTimePicker from "../components/DateTimePicker.vue";
  import AccidentView from "../callcenter/AccidentView.vue";
  import 'vue2-datepicker/index.css';
  import PolicyTypes from "../components/PolicyTypes.vue";

  export default {
    directives: {
      mask,
    },
    components: {
      Phone,
      DateTimePicker,
      Regions,
      PolicyTypes,
      // CommUsers,
      AccidentView,
      // DatePicker
    },
    computed: {
      notfound() {
        return !this.found;
      },

      voluntaryWarn() {
        if (Date.parse(this.item.volEndDate) < Date.parse(new Date)) return true
        return false
      },
      compulsaryWarn() {
        if (Date.parse(this.item.endDate) < Date.parse(new Date)) return true
        return false
      },
    },
    data() {


      var validateDate = (rule, value, callback) => {
        if (Date.parse(this.callDate) < Date.parse(this.item.accidentDate)) {
          callback(new Error("Hadisə tarixi Zəngin tarixindən sonra ola bilməz"));
          return;
        }

        let isInStandardPeriod = this.item.startDate && this.item.endDate &&
          Date.parse(this.item.accidentDate) >= Date.parse(this.item.startDate) &&
          Date.parse(this.item.accidentDate) <= Date.parse(this.item.endDate);

        let isInVoluntaryPeriod = this.item.volStartDate && this.item.volEndDate &&
          Date.parse(this.item.accidentDate) >= Date.parse(this.item.volStartDate) &&
          Date.parse(this.item.accidentDate) <= Date.parse(this.item.volEndDate);
        if (isInStandardPeriod || isInVoluntaryPeriod || this.found) {
          callback();
        } else {
          callback(new Error("Hadisə tarixi sığorta müddətinə aid olmalıdır"));
        }
      };




      return {
        searchPolicyNumber: "",
        oppositeSide: [],
        nextId: null,
        timer: '00:00',
        timeBegan: null,
        timeStopped: null,
        stoppedDuration: 0,
        started: null,
        running: false,
        seconds: 0,
        buttonDisabled: false,
        stopButton: true,
        resetButton: true,
        timeShow: false,
        showModal: false,
        search: "",
        searchType: 1,
        mode: "",
        loading: false,
        item: {},
        policyStatus: {},
        osPolicyStatus: {},
        found: true,
        standalone: standalone,
        insPeriod: [],
        policies: [],
        osPolicies: [],
        policy: [],
        osPolicy: [],
        policyId: null,
        policyIndex: 0,
        policyCount: 0,
        showtext: false,
        isInsured: null,
        isInsuredPhone: null,
        policyNumber: "",
        msg: "",
        recentAccident: {},
        recentAccidentView: {},
        uid: this.$store.state.user.id,
        callDate: null,
        compulsoryPeriod: "",
        voluntaryPeriod: "",
        compulsoryIndex: null,
        voluntaryIndex: null,
        compulsoryStatus: null,
        voluntaryStatus: null,
        compulsoryEndDate: null,
        voluntaryEndDate: null,
        recentAccidentDialog: false,
        labelWidth: '210px',
        selectedType: "2",
        labelPosition: labelPosition,
        accidentDateValue: {
          date: null,
          time: null,
        },

        rules: {
          driver: [
            {
              required: true,
              message: this.$t('Sütun_mütləqdir'),
              trigger: "change",
            },
          ],
          regionId: [
            {
              required: true,
              message: this.$t('Sütun_mütləqdir'),
              trigger: "change",
            },
          ],
          driverDescr: [
            {
              required: true,
              message: this.$t('Sütun_mütləqdir'),
              trigger: "change",
            },
          ],
          accidentCommUid: [
            {
              required: true,
              message: this.$t('Sütun_mütləqdir'),
              trigger: "change",
            },
          ],
          driverPhone: [
            {
              required: true,
              message: this.$t('Sütun_mütləqdir'),
              trigger: "change",
            },
          ],
          accidentDate: [
            {
              type: "date",
              required: true,
              message: this.$t('Sütun_mütləqdir'),
              trigger: "change",
            },
            { validator: validateDate, required: true, trigger: "change" },
          ],
          place: [
            {
              required: true,
              message: this.$t('Sütun_mütləqdir'),
              trigger: "change",
            },
          ],
          policyType: [
            {
              required: true,
              message: this.$t('Sütun_mütləqdir'),
              trigger: "change",
            },
          ],

          approachedOffice: [
            {
              required: true,
              message: this.$t('Sütun_mütləqdir'),
              trigger: "change",
            },
          ],
        },
        optCall: {
          disabledDate: (date) => {
            return new Date() <= date;
          },
        },
        optAccident: {
          disabledDate: (date) => {
            return this.callDate <= date;
          },
        },
      };
    },
    methods: {
      updateOppositeSide(car, property) {
        car[property] = event.target.value;
      },
      addOppositeSide() {

        const previousCount = this.oppositeSide.length;
        const currentCount = this.item.vehicleCount;

        if (currentCount < previousCount) {
          const lastIndex = this.oppositeSide.length - 1;
          this.deleteOppositeSide(lastIndex)
        }
        else if (currentCount > previousCount) {
          let lastId = 0;

          if (this.oppositeSide.length > 0) {
            lastId = this.oppositeSide[this.oppositeSide.length - 1].id;
          }
          this.oppositeSide.push({
            id: lastId + 1,
            accidentId: '',
            customBrandModel: '',
            personName: '',
            orgName: '',
            insuranceCompId: null,
            insuranceType: null,
            startDate: null,
            endDate: null,
            volStartDate: null,
            volEndDate: null,
            voluntaryPeriod: null,
            voluntaryStatus: null,
            voluntaryEndDate: null,
            voluntaryWarn: null,
          });
        }

      }
      ,
      deleteOppositeSide(index) {
        this.oppositeSide.splice(index, 1);
        const previousCount = this.oppositeSide.length;
        this.item.vehicleCount = this.oppositeSide.length;
      },

      start: function () {
        if (this.running) return;

        if (this.timeBegan === null) {
          this.reset();
          this.timeBegan = new Date();
        }
        if (this.timeStopped !== null) {
          this.stoppedDuration += (new Date() - this.timeStopped);
        }
        this.started = setInterval(this.clockRunning, 10);
        this.running = true;
      },
      reset: function () {
        this.running = false;
        clearInterval(this.started);
        this.stoppedDuration = 0;
        this.timeBegan = null;
        this.timeStopped = null;
        this.time = "00:00";
      },
      clockRunning: function () {
        var currentTime = new Date()
          , timeElapsed = new Date(currentTime - this.timeBegan - this.stoppedDuration)
          , min = timeElapsed.getUTCMinutes()
          , sec = timeElapsed.getUTCSeconds()
        this.timer =
          this.zeroPrefix(min, 2) + ":" +
          this.zeroPrefix(sec, 2)
      },
      zeroPrefix: function (num, digit) {
        var zero = '';
        for (var i = 0; i < digit; i++) {
          zero += '0';
        }
        return (zero + num).slice(-digit);
      },
      stop: function () {
        this.running = false;
        this.timeStopped = new Date();
        this.clearInterval(started);
      },
      closeDialog() {
      },
      onIsInsured() {
        if (this.isInsured)
          this.item.driver = this.item.insuredName;
        else
          this.item.driver = "";
      },
      onIsInsuredPhone() {
        if (this.isInsuredPhone) {
          this.item.driverPhone = this.item.phone;
        }
        else {
          this.item.driverPhone = "";
        }
      },
      new() {
        this.activeName = "person";
        this.item = new AccidentType();
        this.policyStatus = new PolicyStatusType();
        this.mode = "New";
        this.showModal = true;
        this.found = false;
        this.policyCount = null
        this.search = null;
        this.callDate = new Date();
        this.timeShow = true;
        this.item.accidentStage = 3;
        this.$nextTick(() => {
          if (this.$refs.policy) {
            this.$refs.policy.clearValidate();
          }
        });
      },
      edit(id) {
        this.loading = true;
        this.activeName = "person";
        this.mode = "Edit";
        this.showModal = true;
        this.search = null;
        this.policyCount = null;
        GetAccident(id).then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.item = response.data.data;
            this.item.callDate = new Date(this.item.callDate);
            this.callDate = this.item.callDate;

            this.accidentDateValue.date = new Date(this.item.accidentDate);
            this.accidentDateValue.time = new Date(this.item.accidentDate);
            this.item.accidentDate = new Date(this.item.accidentDate);
            this.policyId = this.item.policyId;

            this.found = this.item.policyNumber === null;
            this.isInsured = null;
            this.isInsuredPhone = null;
            if (this.item.startDate)
              this.compulsoryPeriod = DateTimeReverseToString(this.item.startDate) + ' - ' + DateTimeReverseToString(this.item.endDate)
            else
              this.compulsoryPeriod = "";
            if (this.item.volStartDate)
              this.voluntaryPeriod = DateTimeReverseToString(this.item.volStartDate) + ' - ' + DateTimeReverseToString(this.item.volEndDate)
            else
              this.voluntaryPeriod = "";
            this.$nextTick(() => {
              if (this.$refs.policy) {
                this.$refs.policy.clearValidate();
              }
            });
          } else {
            this.showModal = false;
            this.$message({
              type: "warning",
              message: "Səhv əməliyyat",
            });
          }
        });
        GetOppositeSides(id).then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.oppositeSide = response.data.data;
          } else {
            this.showModal = false;
            this.$message({
              type: "warning",
              message: "Səhv əməliyyat",
            });
          }
        });
      },
      onAccidentDateChange(date) {
        return this.callDate <= date;
      },

      onCallDateChange() {
        this.item.accidentdate = null;
      },



      handleAccidentView() {
        this.recentAccidentDialog = false;
        this.$refs["accident"].view(this.recentAccidentView);
      },


      redirectToAccident() {
        const url = this.$router.resolve(`/comm/accident/${this.recentAccident.accidentId}`).href;
        window.open(url, '_blank');
      }

      ,
      onsearch(policyNumber) {
        if (!policyNumber.trim()) {
          this.$message({
            type: "error",
            message: "Zəhmət olmasa dövlət qeydiyyat nişanını daxil edin",
          });
          return;
        }
        // this.getRecentAccident();

        // this.$nextTick(() => {
        //   if (this.recentAccident !== null && Object.keys(this.recentAccident).length !== 0) {
        //     this.recentAccidentDialog = true;
        //   }
        // });

        this.loading = true;
        this.isInsured = null;
        this.isInsuredPhone = null;
        this.item.phone = "";

        this.item.policyNumber = policyNumber;

        if (policyNumber === '') {
          this.loading = false;
        }
        // this.resetForm();
        return new Promise(async (resolve, reject) => {
          // let salesApiData, newsalesApiData;

          try {

            this.policies = [
              {
                "policy_type": "İcbari",
                "policy_status": "Buraxılmış",
                "person_type": 1,
                "policy_number": "PP12345678",
                "policy_type_id": 2,
                "person_type_name": "Fiziki şəxs",
                "start_date": "2025-03-13T20:52:42",
                "end_date": "2026-03-13T20:52:42",
                "ident_number": "5TPBYCA",
                "insured_name": "NƏBİYEV FUAD ZAHİR OĞLU",
                "insured_address": "Səməd Vurğun küçesi  № 1",
                "reg_number": "90TV889",
                "phone": "994551121314",
                "beneficiary_name": null,
                "production_year": 2014,
                "kasko_premium_cost": null,
                "kasko_premium": null,
                "is_partial": null,
                "franchise_per_one": null,
                "bi_property": null,
                "bi_premium_cost": null,
                "accident_premium": null,
                "accident_premium_cost": null,
                "total_accident_premium": null,
                "total_accident_premium_cost": null,
                "total_civil_premium": null,
                "total_civil_premium_cost": null,
                "premium": 60.09,
                "branch_name": "Şirkət",
                "insurance_type": 1
              },

            ]

            if (this.policies.length === 0) {
              this.$message({
                type: "error",
                message: "Sığorta şəhadətnaməsi tapılmadı",
              });
            } else {
              this.processPolicies();
            }

            this.loading = false;
            resolve();
          } catch (error) {
            this.$message({
              type: "error",
              message: "Səhvlik baş verdi. Zəhmət olmasa yenidən cəhd edin",
            });
            this.loading = false;
            reject(error);
          }
        });


      },
      processPolicies() {
        this.compulsoryIndex = null;
        this.voluntaryIndex = null;
        this.item.startDate = null;
        this.item.endDate = null;
        this.item.volStartDate = null;
        this.item.volEndDate = null;
        this.compulsoryPeriod = "";
        this.voluntaryPeriod = "";
        this.compulsoryStatus = "";
        this.voluntaryStatus = "";

        const today = new Date();
        for (var i in this.policies) {
          const policy = this.policies[i];
          const start = new Date(policy.start_date);
          const end = new Date(policy.end_date);

          if (policy.policy_type == 'İcbari') {
            if (this.compulsoryIndex === null || new Date(this.policies[this.compulsoryIndex].end_date) < end) {
              this.compulsoryIndex = i;
            }
          } else if (policy.policy_type == 'Kasko' || policy.policy_type == 'Könüllü') {
            if (this.voluntaryIndex === null || new Date(this.policies[this.voluntaryIndex].end_date) < end) {
              this.voluntaryIndex = i;
            }
          }
          // }
        }

        if (this.compulsoryIndex !== null) {
          const compulsoryPolicy = this.policies[this.compulsoryIndex];
          this.compulsoryPeriod = DateTimeReverseToString(compulsoryPolicy.start_date) + ' - ' + DateTimeReverseToString(compulsoryPolicy.end_date);
          this.item.startDate = compulsoryPolicy.start_date;
          this.item.endDate = compulsoryPolicy.end_date;
          this.item.insuranceCompId = 1;
          this.compulsoryStatus = compulsoryPolicy.policy_status;
          this.policyStatus.compulsoryStatus = this.compulsoryStatus;
          this.policyStatus.compulsoryPolicyId = compulsoryPolicy.policy_number;
        }

        if (this.voluntaryIndex !== null) {
          const voluntaryPolicy = this.policies[this.voluntaryIndex];
          this.voluntaryPeriod = DateTimeReverseToString(voluntaryPolicy.start_date) + ' - ' + DateTimeReverseToString(voluntaryPolicy.end_date);

          this.item.volStartDate = voluntaryPolicy.start_date;

          this.item.volEndDate = voluntaryPolicy.end_date;
          this.item.insuranceCompId = 1;
          this.voluntaryStatus = voluntaryPolicy.policy_status;
          this.policyStatus.voluntaryStatus = this.voluntaryStatus;
          this.policyStatus.voluntaryPolicyId = voluntaryPolicy.policy_number;
        }

        this.policy = this.policies[this.voluntaryIndex ? this.voluntaryIndex : this.compulsoryIndex];


        // if (this.policy.policy_number) {
        //   this.item.policyNumber = this.policy.policy_number;
        // } else {
        //   this.item.policyNumber = "N/A";
        // }
        if (this.policy.insured_name) {
          this.item.insuredName = this.policy.insured_name;
        } else {
          this.item.insuredName = "N/A";
        }

        if (this.policy.ident_number) {
          this.item.identNumber = this.policy.ident_number;
        } else {
          this.item.identNumber = "N/A";
        }
        if (this.policy.phone) {
          this.item.phone = this.policy.phone;
        } else {
          this.item.phone = null;
        }

        if (this.policy.branch_name) {
          this.item.branchName = this.policy.branch_name;
        } else {
          this.item.branchName = null;
        }

        this.item.policyId = this.policy.policy_number;
        this.item.policyType = this.policy.policy_type_id;
        this.item.personType = this.policy.person_type;
        this.item.insuranceType = this.policy.insurance_type;
        this.item.insurancePeriod = DateTimeReverseToString(this.item.startDate) + " - " + DateTimeReverseToString(this.item.endDate);
        this.item.policyStatus = this.policy.policy_status;
        this.item.address = this.policy.insured_address;
        this.item.policyNumber = this.policy.policy_number;
      }
      ,

      focusSearch(policyNumber) {
        this.onsearch(policyNumber)
      },
      focusSearchOs(index) {
        this.onsearchOs(index)
      },

      inputDate() {
        if (this.$refs["datePicker"].dateVal && this.$refs["datePicker"].timeVal) {
          this.accidentDateValue.date = this.$refs["datePicker"].dateVal;
          this.accidentDateValue.time = this.$refs["datePicker"].timeVal;

          this.item.accidentDate = new Date(this.accidentDateValue.date.toString().substr(0, 16) + this.accidentDateValue.time.toString().substr(16, 44));
        }
        else {
          this.item.accidentDate = null;
        }
      },
      clickSave() {
        this.$refs["policy"].validate((valid) => {
          if (!valid) {
            this.$message({
              type: "warning",
              message: "Məlumatların tam və düzgün olmasını yoxlayın",
            });
            return false;
          } else {


            this.saveAccident();

          }
        });
      },
      clickReject() {
        this.showModal = false;
        this.loading = false;
        if (this.mode = "New") {
          this.policyStatus.timer = this.timer;
          this.reset();
          this.timeShow = false;
          this.policyStatus.commandUserId = this.uid;
          PolicyStatusInsert(this.policyStatus).then((response) => {
            if (response.data.data) {
              if (!response.data.isSuccess) {
                this.$message({
                  type: "error",
                  message: response.data.errors[0],
                });
              } else {

              }
            } else {
              this.policyStatus = {};
            }
          });
        }

      },
      opened() {
        if (this.mode === 'New') {
          this.oppositeSide = []
          this.accidentDate = null;
          this.accidentDateValue.date = null;
          this.accidentDateValue.time = null;

        }
        this.reset();
        this.start();
        this.resetForm();
        this.addOppositeSide();

      },
      resetForm() {
        this.$nextTick(() => {

          this.item.startDate = null;
          this.item.endDate = null;
          this.item.volStartDate = null;
          this.item.volStartDate = null;
          this.compulsoryPeriod = null;
          this.voluntaryPeriod = null;
          this.voluntaryStatus = null;
          this.compulsoryStatus = null
          this.item.policyId = null;
          this.item.insurancePeriod = "";
          this.item.personType = null;
          this.item.identNumber = null;
          this.item.phone = null;
          this.item.insuredName = null;
          this.item.policyNumber = null;
        })
      },
      saveAccident() {

        this.loading = true;
        let acc = Object.assign({}, this.item);
        acc.commandUserId = this.uid;
        acc.accidentDate = DateTimeToJson(this.item.accidentDate);
        acc.accidentStage = 3
        // acc.customBrandModel = this.item.brandId ? null : this.item.brandModel;

        if (this.mode === "New") {
          acc.callDate = DateTimeToJson(this.callDate);
          CreateAccident(acc).then((response) => {
            this.loading = false;
            if (response.data.data) {
              if (!response.data.isSuccess) {
                this.$message({
                  type: "error",
                  message: response.data.errors[0],
                });
              } else {
                
                this.showModal = false;
                this.$message({
                  type: "success",
                  message: "Uğurlu əməliyyat",
                });
                // Fonksiyonu burada tanımla
                let processItems = async () => {
                  for (let item of this.oppositeSide) {
                    item.accidentId = response.data.data.id;
                    let result = await CreateOppositeSide(item);

                    if (result.data && result.data.status !== 1) {
                      this.$message.error(result.data.message);
                    }
                  }
                }

                // Ve burada çağır
                processItems();
                this.policyStatus.accidentId = response.data.data.value;
                this.policyStatus.timer = this.timer;

                this.policyStatus.commandUserId = this.uid;

                PolicyStatusInsert(this.policyStatus).then((response) => {
                  if (response.data.data) {
                    if (!response.data.isSuccess) {
                      this.$message({
                        type: "error",
                        message: response.data.errors[0],
                      });
                    } else {

                    }
                  } else {
                    this.policyStatus = {};
                  }
                });
              }
            } else {
              this.$message({
                type: "error",
                message: "Səhv əməliyyat",
              });
            }
          });

        } 
      },
      handleKeyDown(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.showConfirmationDialog();
        }
      },
      showConfirmationDialog() {
        if (confirm('Pəncərəni bağlamaq istəyirsiz?')) {
          this.showModal = false;
        }
      },
      updateLabelWidth() {
        if (window.innerWidth <= 1024) {
          this.labelWidth = '125px';
        } else {
          this.labelWidth = '210px';
        }
      }
    },
    mounted() {
      document.addEventListener('keydown', this.handleKeyDown);

    },
    beforeDestroy() {
      document.removeEventListener('keydown', this.handleKeyDown);
      window.removeEventListener('resize', this.updateLabelWidth);

    },
    created() {
      this.updateLabelWidth();
      window.addEventListener('resize', this.updateLabelWidth);
    },
  };
</script>



<style lang="scss">
  .customDialog.el-dialog {
    z-index: 0;

    .el-dialog__body {
      padding: 0px 20px;
      color: var(--font-primary) !important;
      font-size: var(--font-large);
      word-break: break-all;
    }

    .el-dialog__header {
      padding: 10px 20px 10px;
    }
  }

  .mx-datepicker-popup {
    z-index: 3000;
  }
</style>